import React from 'react';
import AffiliateText from "./AffiliateText";
import styled from 'styled-components';
import {BodyContainer} from "../Container/Container";

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 18px;
  align-items: center;
  
  @media(min-width: 768px) {
      grid-template-columns: 2fr 3fr;
      grid-column-gap: 36px;
  }
`;

const Img = styled.img`
  width: 100%;
  height: auto;
  order: 1;
`;

const StyledBodyContainer = BodyContainer.extend`
  background-size: contain;
  padding: 0 16px 32px;
`;

const
  SecondAffiliate = (props) => {
      const {side_image, logo: {source_url}, ...affiliate} = props.affiliate.node.acf;
      return (
        <StyledBodyContainer style={{background: `url(${source_url}) no-repeat right`}}>
            <Container>
                <Img
                  src={side_image.source_url}
                  alt={side_image.alt_text}
                />
                <AffiliateText
                  affiliate={affiliate}
                />
            </Container>
        </StyledBodyContainer>
      );
  };

export default SecondAffiliate;



// WEBPACK FOOTER //
// ./src/components/Affiliations/SecondAffiliate.js